export * as coreLib from 'html-to-image'
